export const shippingPolicyText = `
Shipping Policy

Eveness is proud to offer fast shipping at affordable prices. The shipping fee for each order is based on the package weight, destination, and shipping method. For the most accurate shipping information, use the "Get shipping quote" link on the product pages or in your shopping cart.

Shipping Location & Cost

We currently offer FREE Shipping exclusively to customers in the United States. This free shipping will be displayed during checkout.

Exclusive Collections Shipping

Exclusive collection products are currently available for shipping only to customers located in the United States and the European Union (EU). Shipping availability, costs, and delivery times for exclusive collection products may vary depending on the destination and will be displayed during checkout where applicable.

Shipping Methods and Transit Times

Eveness ships orders from our Los Angeles, California, location. On occasion, orders will be fulfilled directly by the manufacturer or distributor in order to reduce the shipping time. The shipping times below refer to items labeled with an availability of In Stock - Ships the Same or Next Business Day.

Shipping Method: Standard Shipping
Handling Time: 1-2 business days (Monday to Friday)
Transit or Delivery Time: 3-7 business days (Monday to Friday)
Total Delivery Time: 4-9 business days
Order Cut-off Time: 5:00 PM (GMT -08:00) Pacific Standard Time (Los Angeles)

United States Customers:

The shipping methods listed above are for residential and commercial destinations within the continental 48 United States. Eveness primarily uses FedEx to ship orders. To provide the most affordable rates, small items shipped via Standard Flat Rate or USPS First Class Mail will be delivered through a joint effort by DHL and USPS. Shipments to military addresses and PO Boxes will only ship via USPS. When shipping to a military APO/FPO/DPO address, we strongly recommend choosing USPS Priority as the shipping time is much quicker than Parcel.

Shipment Confirmation & Order Tracking

Once an order has been shipped, we send our customers an email with the tracking number for the order. Click on the tracking link in the email to follow the location of the package on the carrier's website. If you did not receive a tracking number by email or need to confirm the tracking information, please contact us at Team@eveness.ai or call us at +1 8188499559.

Order Processing

Each order placed on Eveness goes through our processing department before it can be shipped. If 3 business days have passed since you submitted payment and you have not received an email with tracking information, please log in to your account to track your orders and/or contact us immediately via email or phone. Customers who do not receive a tracking number within 3 days will receive an order status update via email.

Shipping to Alternate Address

Orders with different billing and shipping addresses may require longer processing times due to an additional verification procedure. The additional verification and processing time are in an effort to protect our customers from online fraud.

Shipping Changes Fees (Address Intercept)

If a request to change the shipping address is made after the package leaves the Eveness warehouse, it is subject to an Address Intercept Fee imposed by the shipping carrier. The amount of the fee varies according to the shipping carrier and the destination of the package. Eveness will do its best to work with the shipping carriers to make these changes so that your package arrives at the correct address. Please be aware that not all shipping carriers will accept address intercept changes. This policy is in accordance with the security measures and agreements made with our third-party shipping companies.

Signature Required

Due to the valuable contents of some shipments, Eveness may require a signature upon delivery. Such guidelines will not be overruled upon the customer's request. Please understand that this is a security measure taken by our Company to ensure the safe delivery of each package and guarantee excellent service. Many of our third-party shipping carriers and payment companies require signatures upon delivery to protect against fraud and theft. Customers may request a signature upon delivery by calling Eveness Customer Service at +1 8188499559.

Shipping Policy Disclaimer

Delivery estimates do not apply to items shipped directly from the manufacturer, nor out-of-stock items. Some items that ship from the manufacturer can only be delivered to addresses within the 48 continental states.

Standard delivery time for domestic customers will average from 2-7 business days. Saturday, Sunday and national holidays are not considered business days for delivery purposes.

Our Shipping Guarantee applies only to shipments delayed due to our service failure. We will not guarantee shipments that are delayed due to an act of god, such as weather, a catastrophic event, or failure by our delivery partners. Our guarantee is also voided if incorrect billing or shipping information is given and results in your order being delayed to its destination. Our guarantee is also void if no one is available to sign for shipment when delivery attempt is made if a signature is required.

Cancellations

Once an order is placed, it enters our processing queue immediately. Due to the speed and efficiency of our order preparation, we are unable to cancel orders once they have been confirmed. We appreciate your understanding and are dedicated to ensuring a quick and seamless delivery experience. If you ordered wrong item(s) and wanted to cancel the item and order the right one, then please contact us at Team@eveness.ai or call us at +1 8188499559.

If you have more questions about our policies and business, please check our FAQs page.

Questions and Contact Information

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const returnRefundText = `
Return & Exchange Policy

Eveness wants to make sure that you are completely satisfied. If, for some reason, you aren't happy with product(s) and want to return them, we make returns simple.

30-Day Returns

You may return or exchange a complete, new product within 30 days.

Items must be:
- Unworn
- Unwashed
- With original tags attached
- In original packaging

Important Details and Exclusions

Refund or exchange option: You may choose an exchange or a refund for the product returned.

Refund method: Refunds are issued to the same credit card, debit card, PayPal, gift certificate, store credit account, or other form of payment used on your original transaction. Only money orders are non-refundable and instead issued as store credit upon return.

Non-refundable exclusions: Include select products such as those noted as non-refundable in the product description, pre-cut wire, all software, downloads or digital content, installation labor, and special order or made-to-order products (e.g. vehicle alternators).

Products must be new and show no signs of use or installation, or Eveness will refuse the return or charge a restocking fee.

Exclusive Collections Policy

- Exclusive products are not eligible for returns, exchanges, or refunds
- By purchasing an exclusive collection product, you acknowledge and agree that the sale is final. The standard Eveness return and refund policy does not apply to these products.
- Please carefully review the product details, sizing information, and order information before completing your purchase.

Examples of conditions that will lead to refused returns or a restocking fee include:

- Any sign of use
- Tags, stickers, and other manufacturer labels removed or tampered with
- Missing parts or the original product packaging are damaged or tampered with
- A different serial number than the one Eveness shipped
- Physical damage from drops, liquid, mishandling, or similar
- Product(s) returned that were damaged due to improper packaging

Bonus products, promotional bundles, free accessories, loyalty points and gift cards or other products that are not returned but were included in a promotion with the product returned, will have their full individually listed price deducted from any credit or refund issued. Similarly, promotional products that are returned without their corresponding bundled product may not be credited.

Damaged product and/or shipping box from the shipment must be reported within 14 calendar days from your delivery date.

When will I get my refund or replacement?

After we receive your product, we normally process your exchange or refund within three business days. Some products require additional testing or evaluation.

How will I know if you've received my return?

We will email you a Return Received notice detailing that your return has been received. An additional email will be sent following the completion of the return process.

Defective Products

A defective product is covered through an exchange of the same product within our return period. If the product is discontinued, you will be eligible for a non-refundable store credit towards another product. After 30 days, the defective product is covered under warranty coverage as stated above.

Any product missing manufacturer packaging, accessories or parts, including those promotional in nature, will be exchanged only for the same product with the aforementioned packaging, accessories and parts not being included upon the exchange. We exchange exactly what you send us.

In the event a product is returned missing accessories and/or packaging, and the product is not in stock for exchange, we will send the product for warranty repair, regardless of the purchase date.

Return Shipping Costs

For most returns, we offer an incredibly discounted UPS Shipping Label program for US customers that can be purchased directly through your Eveness account.

Original shipping costs are deducted from your refund, store credit or exchange towards alternate products.

Missing a Package or Never Received Your Order?

If your tracking information shows that your package was delivered but you cannot find it, please do the following within 48 hours of the expected delivery:

- Verify the shipping address on the order is where you have been looking for the package
- Look for a notice of attempted delivery
- Look around the delivery location for your package
- See if someone else, such as a neighbor or co-worker, has accepted the delivery
- Some packages travel through multiple carriers; check your mailbox or wherever else you receive mail or packages

If you are still facing any issues, then please contact us at Team@eveness.ai or call us at +1 8188499559.

If you have more questions about our policies and business, please check our FAQs page.

Contact Us

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const disclaimerText = `
Disclaimer

Welcome to Eveness AI. By using our website, platform, and services, you acknowledge and agree to the terms outlined in this Disclaimer. Please read this page carefully before using our services.

General Information

The information provided on this website is for general informational and educational purposes only. While we strive to keep all content accurate, updated, and reliable, Eveness AI makes no guarantees regarding the completeness, accuracy, reliability, or suitability of any information, recommendations, or services available on the platform.

AI-Generated Recommendations

Eveness AI uses artificial intelligence and automated technologies to provide outfit suggestions, virtual try-on experiences, styling recommendations, and sizing guidance. These recommendations are generated based on available data, algorithms, and user inputs and should be considered as guidance only.

Actual product appearance, fit, color, texture, and sizing may vary depending on factors such as brand specifications, lighting, device display settings, and individual body proportions.

No Professional Fashion or Medical Advice

The content and recommendations provided by Eveness AI do not constitute professional fashion consulting, medical advice, body analysis, or personal styling services. Users should use their own judgment before making purchasing or styling decisions.

Third-Party Products and Links

Our platform may include links to third-party websites, products, services, or partner brands. Eveness AI does not control or endorse the content, policies, or practices of any third-party websites and is not responsible for any transactions, damages, or issues arising from their use.

Limitation of Liability

Eveness AI shall not be held liable for any direct, indirect, incidental, consequential, or special damages arising from the use of, or inability to use, our platform, services, recommendations, or website content.

Users are solely responsible for how they use the information and recommendations provided on the platform.

Technology Limitations

While we continuously improve our AI systems and virtual try-on technology, no AI-generated experience can guarantee 100% accuracy. Results may vary based on uploaded images, measurements, product data, and system limitations.

Changes to This Disclaimer

We reserve the right to update, modify, or change this Disclaimer at any time without prior notice. Any updates will be posted on this page with the revised effective date.

Contact Us

If you have any questions regarding this Disclaimer, then please contact us at Team@eveness.ai or call us at +1 8188499559.

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const paymentPolicyText = `
Payment Policy

We accept all major credit cards, Apple Pay, Google Pay, Shop Pay, and payments made through PayPal. Payment must be made in full before shipment. You don't have to buy now, pay later set up on Google.

If you wish to pay with your credit card, please use the "Proceed to Checkout" option on the shopping cart page. You may pay using your Visa, MasterCard, American Express, or Discover/Diners card.

In cooperation with Klarna, we offer you various payment options. Please see checkout for more information.

In order to be able to offer you Klarna's payment options, we will pass to Klarna certain aspects of your personal information, such as contact and order details, in order for Klarna to assess whether you qualify for their payment options and to tailor the payment options for you. Your personal data is handled in accordance with applicable data protection law.

In addition, you can use PayPal. There is no need to be a PayPal member in order to pay with a credit card through PayPal. Please use the "Checkout With PayPal" option on the shopping cart page.

Our payment system has 2048-bit encryption and secure servers, which enable you to make your payment with complete confidence.

Your credit card information is not processed through or stored on our servers, and no information is ever released to a third party.

We reserve the right to make changes in our policies at any given time. Notification of such changes will be posted on this page. If you have any questions or comments about any of our policies, please contact us.

If you are still facing any issues, then please contact us at Team@eveness.ai or call us at +1 8188499559.

If you have more questions about our policies and business, please check our FAQs page.

Questions and Contact Information

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const fraudSpamPolicyText = `
Fraud & Spam Policy

At Eveness, we are committed to providing a safe and trustworthy shopping experience for all our customers. We take fraud prevention and spam protection seriously, and we have strict measures in place to detect and prevent fraudulent activities, including fake or misleading reviews.

Fraud Prevention Measures

- We use secure payment gateways and encryption to protect customer data.
- All transactions are monitored for suspicious activity.
- Orders flagged for unusual behavior, such as multiple failed payment attempts or mismatched billing/shipping addresses, are manually reviewed before processing.
- Accounts or transactions identified as fraudulent are immediately suspended or cancelled.

Spam & Fake Review Prevention

- Customer reviews are scanned manually and automatically by apps to flag spam or irrelevant content.
- Reviews are verified against confirmed purchases wherever possible.
- Any review found to be fake, misleading, or abusive will be removed.
- Customers violating our review policies may be restricted from leaving further reviews.

Reporting Fraud or Spam

We encourage customers to report any suspicious activity or content. You can contact our support team at Team@eveness.ai or call us directly at +1 8188499559.

Our Commitment

Our team is dedicated to maintaining a secure, transparent, and trustworthy shopping environment. We regularly review and update our policies to ensure the highest standards of fraud detection and prevention.

If you are still facing any issues, then please contact us at Team@eveness.ai or call us at +1 8188499559.

If you have more questions about our policies and business, please check our FAQs page.

Contact Us Now for Assistance

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const faqsText = `
Frequently Asked Questions

1. What is Eveness AI?

Eveness AI is an AI-powered fashion platform that helps users discover outfits, get personalized style recommendations, use virtual try-on features, and find the right clothing size with smart AI technology.

2. How accurate is the AI sizing recommendation?

Our AI sizing guide uses body shape analysis, fit preferences, and clothing data to recommend the most suitable size. While recommendations are highly accurate, fit may vary slightly depending on the brand and garment style.

3. Is my uploaded photo secure?

Yes, we take user privacy seriously. Uploaded photos and personal information are securely processed and protected according to our privacy standards.

4. Can Eveness recommend outfits based on my style?

Yes. Our AI analyzes your preferences, body shape, and fashion interests to generate personalized outfit suggestions tailored to your style.

5. How can I place an order?

You can place an order directly on our website by adding products to your cart and proceeding to checkout. We offer multiple payment options for your convenience.

6. What payment methods do you accept?

We accept credit/debit cards, PayPal, bank transfers, and other secure payment methods. You can see the full list of accepted payment options at checkout.

7. How long does shipping take?

Shipping times vary based on your location and the selected shipping method. Typically, orders are delivered within 3-7 business days. You will receive a tracking number once your order is shipped.

8. Can I return or exchange a product?

Yes, we have a hassle-free return and exchange policy. If you receive a defective or incorrect item, you can return it within the specified return period. Please refer to our return policy for more details.

9. Do you offer international shipping?

Yes, we ship internationally. Shipping costs and delivery times vary depending on the destination. You can check the shipping options at checkout.

If you are still facing any issues, then please contact us at Team@eveness.ai or call us at +1 8188499559.
`;

export const aboutUsText = `
About Eveness

At Eveness AI, we believe fashion should feel personal, confident, and accessible for everyone. Our mission is to transform the online shopping experience through intelligent AI technology that helps people discover styles they truly love while reducing the uncertainty of online fashion shopping.

Eveness combines AI-powered virtual try-on, smart sizing guidance, body-shape analysis, and personalized outfit recommendations into one seamless fashion experience. By understanding individual preferences, proportions, and style goals, our platform helps users visualize outfits, explore new looks, and shop with greater confidence.

We created Eveness to solve some of the biggest challenges in fashion eCommerce: sizing confusion, lack of personalization, and high product return rates. Traditional online shopping often leaves customers unsure about how clothing will fit or look in real life. Our AI-driven technology is designed to bridge that gap by making fashion discovery smarter, more interactive, and more personalized.

Our platform uses advanced artificial intelligence to analyze style preferences, body shape, and outfit compatibility in order to deliver tailored recommendations that fit both the user and their lifestyle. From virtual styling assistance to outfit generation and AI sizing support, Eveness helps users make more confident fashion decisions.

At Eveness, innovation and inclusivity are at the center of everything we build. We are continuously improving our technology to create a more realistic, intelligent, and engaging shopping experience for modern consumers and fashion brands alike.

Our vision is simple: to make online fashion shopping more personalized, more accurate, and more enjoyable for everyone.

Why Choose Us?

At Eveness AI, we combine advanced AI technology with personalized fashion experiences to make online shopping smarter and more confident. From AI-powered virtual try-on and accurate sizing recommendations to personalized outfit suggestions, our platform is designed to help users discover styles that truly fit their body, preferences, and lifestyle. We focus on innovation, convenience, and inclusivity to create a seamless fashion experience for everyone.

Contact Us Now for Assistance

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const contactUsText = `We love to hear from you on our customer service, products, website, or any topics you want to share with us. Your comments and suggestions are appreciated. So, please contact us.

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;

export const trackYourOrderText = `
Track Your Order

Once your order has been shipped, Eveness will send you an email with the tracking number for your order. You can click the tracking link in that email to follow your package on the carrier's website.

If you did not receive a tracking number by email or need help confirming your tracking information, please contact us at Team@eveness.ai or call us at +1 8188499559.

Business Name: Eveness
Website: www.eveness.ai
Phone: +1 8188499559
Email: Team@eveness.ai
Address: 1800 E Washington Blvd, Los Angeles, CA 90021 USA
Customer Service: Monday-Friday 10:00 AM - 5:00 PM Pacific Standard Time (GMT-8)
Response Time: Within 24-48 hours.
`;